/**
 * Formats a number by adding a thousands separator.
 * @param {number} number - The number to format.
 * @returns {string} The formatted number with thousands separator.
 */
export function formatThousand(number) {
	const parts = number.toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
	return parts.join(".");
}

/**
 * Rounds a number to the nearest five cents.
 * @param {number} number - The number to round.
 * @returns {number} The number rounded to the nearest five cents.
 */
export function roundToNearestFiveCents(number) {
	return Math.round(number * 20) / 20;
}

/**
 * Formats a number as a Swiss Franc amount.
 * @param {number} number - The number to format.
 * @returns {string} The formatted Swiss Franc amount.
 */
export function formatFranc(number) {
    const roundedNumber = roundToNearestFiveCents(number);
	const formattedNumber = formatThousand(roundedNumber.toFixed(2));

	if (formattedNumber.endsWith(".00")) {
		return `CHF ${formattedNumber.slice(0, -3)}.-`;
	} else {
		return `CHF ${formattedNumber}`;
	}
}
